import {extent} from 'd3-array';
import {isValid} from 'validators/number-validator';

export default (series, clampToZero = false) => {
  if (!series || !series.length) {
    return [0, 0];
  }

  // Create aggregate values across series
  const numReadings = Math.max(...series.map((serie) => serie.data.length));
  const pos = Array.from({length: numReadings}, () => 0);
  const neg = Array.from(pos);
  for (let ii = 0, nn = numReadings; ii < nn; ii++) {
    series.forEach((datum, index) => {
      const reading = series[index].data[ii];
      const value = reading ? reading.value : 0;
      if (value > 0) {
        pos[ii] += value;
      }
      if (value < 0) {
        neg[ii] += value;
      }
    });
  }

  // Get highest and lowest values in aggregates
  const extents = extent([...pos, ...neg], (datum) => datum);
  const max = isValid(extents[1]) ? extents[1] : 0;
  let min = isValid(extents[0]) ? extents[0] : 0;
  if (clampToZero && min > 0) {
    min = 0;
  }
  return [min, max];
};
